module.exports = "/static-assets/_next/static/images/img-6ac59a0c10-d26f401e2bb7f5172efb43ad8a876d89.webp";